import Vue from 'vue';
import axios from 'axios';

import { Config } from '@/config';

export const geoNotifPermissions = {
  namespaced: true,
  state: {
    status: undefined,
    location: undefined,
    auto_location: false,
    notificationPermission: false,
    lastError: undefined,
  },
  actions: {
    setStatus({ commit, mutation }, value) {
      if (value === true) {
        mutation('accept');
      } else if (value === false) {
        mutation('refuse');
      } else {
        commit('resetStatus');
      }
    },
    refuse({ commit }) {
      commit('refuse');
    },
    accept({ commit }) {
      commit('accept');
    },
    resetState({ commit }) {
      commit('resetState');
    },
    async getLocation({ commit }) {
      if (!('geolocation' in navigator)) {
        commit('error', 'GPS location is not available on this device');
        return;
      }
      // get location
      navigator.geolocation.getCurrentPosition(
        pos => {
          commit('setAutoLocation', true);
          commit('setLocation', {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
          // dispatch('getAddress', { lat: pos.coords.latitude, lng: pos.coords.longitude });
        },
        err => {
          commit('error', err.message);
        },
      );
    },
    async getAddress({ commit }, location) {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${location.lng},${location.lat}.json?access_token=${Config.MAPBOX.TOKEN}&country=FR&language=fr&limit=1&types=address,postcode`,
      );
      if (response.data !== undefined) {
        if (response !== undefined && response.data !== undefined && response.data.features !== undefined && response.data.features.length > 0) {
          commit('setAddress', response.data.features[0].place_name);
          commit('setLocation', {
            lat: response.data.features[0].center[1],
            lng: response.data.features[0].center[0],
          });
        }
      }
    },
    async getLocationWithAddress({ commit }, address) {
      const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?access_token=${Config.MAPBOX.TOKEN}&country=FR&language=fr&limit=1&types=address,postcode`);
      if (response.data !== undefined) {
        if (response !== undefined && response.data !== undefined && response.data.features !== undefined && response.data.features.length > 0) {
          commit('setAddress', response.data.features[0].place_name);
          commit('setLocation', {
            lat: response.data.features[0].center[1],
            lng: response.data.features[0].center[0],
          });
        } else {
          commit('setLocation', undefined);
        }
      }
    },
    setAddress({ commit }, address) {
      commit('setAddress', address);
    },
    async setLocation({ commit }, location) {
      commit('setLocation', location);
    },
    getNotificationPermission({ commit }) {
      Notification.requestPermission(function (status) {
        if (status === 'granted') {
          commit('setNotificationPermission', true);
        } else {
          commit('setNotificationPermission', false);
        }
      });
    },
  },
  mutations: {
    accept(state) {
      Vue.set(state, 'status', true);
    },
    refuse(state) {
      Vue.set(state, 'status', false);
    },
    resetStatus(state) {
      Vue.set(state, 'status', undefined);
    },
    setLocation(state, location) {
      Vue.set(state, 'location', location);
    },
    setAutoLocation(state, isAutoLocation) {
      Vue.set(state, 'auto_location', isAutoLocation);
    },
    setAddress(state, address) {
      Vue.set(state, 'address', address);
    },
    setNotificationPermission(state, notificationPermission) {
      Vue.set(state, 'notificationPermission', notificationPermission);
    },
    error(state, errorMessage) {
      console.log(errorMessage);
      Vue.set(state, 'lastError', errorMessage);
    },
    resetState(state) {
      Vue.set(state, 'status', undefined);
      Vue.set(state, 'location', undefined);
      Vue.set(state, 'auto_location', false);
      Vue.set(state, 'address', '');
      Vue.set(state, 'notificationPermission', false);
      Vue.set(state, 'lastError', undefined);
    },
  },
  getters: {},
};
